import React from 'react';
import * as Sentry from '@sentry/react'
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";

import { getDeviceTalId } from './config';  // 通用的设置 tag 函数

const setSentry = async(env) => {
    try {
        const talId = await getDeviceTalId()
        const dsnTest = 'https://585db574e49148ab9ae5f125d584690b@sea-sentry.thinkbuddy.com//98'
        const dsnProd = 'https://f058b6219cdb44119a0adac0cc630939@sea-sentry.thinkbuddy.com//99'
        const dsn = env === 'pro' ? dsnProd : dsnTest

        Sentry.init({
            dsn,
            // integrations: [new Integrations.BrowserTracing()], 
            integrations: [
                Sentry.reactRouterV6BrowserTracingIntegration({
                    useEffect: React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes,
                }),
            ],

            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            tracesSampleRate: 0.2,
            // 添加额外参数
            initialScope: (scope) => {
                scope.setTags({ appEnv: env, userId: talId });
                return scope;
            },
            release: '1.0.0'
        });
    } catch (error) {
        console.log('Sentry error')
    }
}
export default setSentry
